import { RootState } from "@/store/types";
import { GetterTree } from "vuex";
import { StatisticState } from "./types";

export const getters: GetterTree<StatisticState, RootState> = {
  telegramOtpStatisticDetail: (state) => state.telegramOtpStatisticDetail,
  telegramOtpStatisticGroup: (state) => state.telegramOtpStatisticGroup,
  telegramOtpGroupBy: (state) => state.telegramOtpGroupings.telegramOtpGroup,
  telegramOtpGroupByOptionally: state => state.telegramOtpGroupings.telegramOtpGroupOptionally,
};
